import { AdvancedDialog, TimelineItem } from '@yaradigitallabs/ahua-react';
import { getBackfillStatusIcon } from '@/features/backfill/utils/backfill.helpers.ts';
import BackfillModalErrorTable from '@/features/backfill/components/statusModal/BackfillModalErrorTable.tsx';
import type { BackfillExecutions } from '@/features/backfill/types/backfill.types.ts';

interface BackfillErrorStatusModalProps {
  execution: BackfillExecutions | null;
}

const BackfillErrorStatusModal = ({
  execution,
}: BackfillErrorStatusModalProps) => {
  if (!execution) return null;
  const hasErrors = execution.status === 'ERROR';
  const statusIcon = getBackfillStatusIcon(execution.status);
  return (
    <AdvancedDialog>
      <AdvancedDialog.Trigger asChild>
        <TimelineItem>
          <TimelineItem.IconButton
            colorConcept={statusIcon.colorConcept}
            icon={statusIcon.icon}
            size="xs"
            title={statusIcon.title}
          />
        </TimelineItem>
      </AdvancedDialog.Trigger>
      {hasErrors && (
        <AdvancedDialog.Content size="l">
          <AdvancedDialog.Start>
            <AdvancedDialog.Title>Error Details</AdvancedDialog.Title>
            <AdvancedDialog.Close>
              <TimelineItem.IconButton
                colorConcept="brand"
                icon="Close"
                size="xs"
              />
            </AdvancedDialog.Close>
          </AdvancedDialog.Start>
          <AdvancedDialog.Middle>
            <div>
              {!hasErrors ? (
                <div className="text-center py-8 text-gray-500">
                  No error details available.
                </div>
              ) : (
                <div className="space-y-6">
                  <BackfillModalErrorTable
                    failedExecutions={execution.failed_executions}
                  />
                </div>
              )}
            </div>
          </AdvancedDialog.Middle>
        </AdvancedDialog.Content>
      )}
    </AdvancedDialog>
  );
};

export default BackfillErrorStatusModal;
